<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<v-card-text class="pt-0">
			<v-row dense>
				<v-col cols="12" class="d-flex">
					<div style="width: 200px;">
						<v-select :items="yearItems" v-model="query.year" item-text="name" item-value="value"
							label="年份" dense outlined></v-select>
					</div>
					<v-btn class="ml-2" color="info" @click="refresh">查询</v-btn>
					<v-spacer></v-spacer>
					<span class="text-h6 mr-3">{{summaryText}}</span>
				</v-col>
			</v-row>
			<v-row dense>
				<!-- <v-col cols="12">
					<v-card>
						<v-card-title class="d-flex">
							<div class="mt-n5">月度缴费&消课收入</div>
							<v-spacer></v-spacer>
							<span>{{summaryText}}</span>
						</v-card-title>
						<v-card-text>
							<ve-histogram  :data="chartData" :extend="chartExtend" :judge-width="true" height="400px"  date-empty="暂无数据"></ve-histogram>
						</v-card-text>
					</v-card>
				</v-col> -->
				<v-col cols="6">
					<v-card>
						<v-card-title class="d-flex">
							<div>月度缴费金额</div>
						
							
						</v-card-title>
						<v-card-text>
							<ve-histogram  :data="monthRechargeData" :extend="chartExtend" :judge-width="true" height="400px"  date-empty="暂无数据"></ve-histogram>
						</v-card-text>
					</v-card>
				</v-col>
				<v-col cols="6">
					<v-card>
						<v-card-title class="d-flex">
							<div>月度消课收入</div>
							<v-spacer></v-spacer>
							
						</v-card-title>
						<v-card-text>
							<ve-histogram  :data="monthRevenueData" :extend="chartExtend" :judge-width="true" height="400px"  date-empty="暂无数据"></ve-histogram>
						</v-card-text>
					</v-card>
				</v-col>
				<v-col cols="6">
					<v-card v-if="courseRevenueData.rows.length>0">
						<v-card-title class="d-flex">
							<div>课程消课收入 TOP5</div>
							<v-spacer></v-spacer>
						</v-card-title>
						<v-card-text>
							<ve-pie :data="courseRevenueData" :judge-width="true"></ve-pie>
						</v-card-text>
					</v-card>
				</v-col>
				<v-col cols="6">
					<v-card v-if="classRevenueData.rows.length>0">
						<v-card-title class="d-flex">
							<div>班级消课收入 TOP5</div>
							<v-spacer></v-spacer>
						</v-card-title>
						<v-card-text>
							<ve-pie :data="classRevenueData" :judge-width="true"></ve-pie>
						</v-card-text>
					</v-card>
					
				</v-col>
				
			</v-row>
			
		</v-card-text>

	</v-card>
</template>

<script>
	import utils from "../../../config/utils"
	export default {
		name: "recharge-dashboard",
		data() {
			this.chartExtend = {
			 //  title: {
				// text: '缴费&消课收入报表'
			 //  },
			  series: {
				barWidth: 40,
				label:{show:true,position:'top'}
			  }
			},
			this.rechargeExtend={
				series: {
					barWidth: 40,
					label:{show:true,position:'right'}
				}
			}
			return {
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '数据报表',
						disabled: true
					},
					{
						text: '缴费&消课收入报表',
						disabled: true
					},
				],
				shopId:"",
				yearItems:[],
				chartData: {
					columns: ['月份', '缴费金额',"消课收入"],
					rows: [], 
				},
				summaryText:"",
				query: {
					year:""+new Date().getFullYear()
				},
				chartData: {
					columns: ['月份', '缴费金额',"消课收入"],
					rows: [], 
				},
				monthRechargeData: {
					columns: ['月份', '缴费金额'],
					rows: [], 
				},
				monthRevenueData: {
					columns: ['月份', "消课收入"],
					rows: [], 
				},
				courseRevenueData: {
					columns: ['课程名称', '消课收入'],
					rows: [], 
				},
				classRevenueData:{
					columns: ['班级名称', '消课收入'],
					rows: [], 
					
				}
			}
		},
		mounted() {

		},
		created() {
			this.generateYearItems();
			this.shopId = utils.getCurrentShopId();
			this.getChartData();
			this.getCourseRevenueTopList();
			this.getClassRevenueTopList();
		},
		methods: {
			generateYearItems(){
				let fromYear = 2018;
				const now = new Date();
				const nowYear = now.getFullYear();
				
				for (let i = fromYear; i <= nowYear; i++) {
					this.yearItems.push({value:i.toString(),name:i.toString()+"年"})
				}
			},
			refresh(){
				this.getChartData();
				this.getCourseRevenueTopList();
				this.getClassRevenueTopList();
			},
			getChartData() {
				const that = this;

				let url = `/report/recharge/dashboard/${this.query.year}?v=1`;
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				
				this.axios.get(url).catch(()=>{
					return;
				}).then(response => {
					
					if (response.data["code"] === 200) {
						
						console.log(response.data["data"]["dataList"]);
						
						const dataList = response.data["data"]["dataList"] || [];
						
						let rechargeList = [];
						let revenueList = [];
						if (dataList.length > 0){
							dataList.forEach((item,index)=>{
								let recharge = {"月份":item.month,"缴费金额":item.rechargeAmount}
								let revenue = {"月份":item.month,"消课收入":item.revenueAmount}
								rechargeList.push(recharge);
								revenueList.push(revenue);
								
							})
						}
						
						// 按月充值金额
						that.monthRechargeData.rows = rechargeList;
						// 按月消课收入
						that.monthRevenueData.rows = revenueList;
						
						
						that.summaryText  =  response.data["data"]["summaryText"];
						return
					}else{
						that.$noty.error("获取失败：" + response.data["message"]);
					}
				
					
				})
			},
			getCourseRevenueTopList(){
				// 获取课程消课排行
				const that = this;
				let url = `/report/course/revenue/amount/top/5?v=1`;
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				if(this.query.year){
					url += "&year=" + this.query.year;
				}
				
				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						const dataList = response.data["data"]["dataList"] || [];
						console.log("course top 5",dataList);
						
						that.courseRevenueData.rows = dataList;
						
						return
					}
				})
			},
			getClassRevenueTopList(){
				// 获取班级消课排行
				const that = this;
				let url = `/report/class/revenue/amount/top/5?v=1`;
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				if(this.query.year){
					url += "&year=" + this.query.year;
				}
				
				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						const dataList = response.data["data"]["dataList"] || [];
						console.log("class top 5",dataList);
						
						that.classRevenueData.rows = dataList;
						
						return
					}
				})
			}
		}
	}
</script>

<style>
</style>
